<template>
  <div ref="signup" v-if="components[mod]" :class="`yxtbiz-signup ${mod}`">
    <component ref="refSignup" :class="align === 'center' ? 'align-items-center' : ''" :is="components[mod]" v-bind="{...$props}" v-on="{...$listeners}">
      <template slot="content">
        <slot name="content"></slot>
      </template>
      <template slot="condition">
        <slot name="condition"></slot>
      </template>
    </component>
    <!--结果弹窗-->
    <yxtf-dialog
      :custom-class="`yxtbiz-signup ${dialogClass}`"
      :padding-size="dialogPaddingSize"
      :title="dialogTitle"
      :center="dialogCenter"
      :visible.sync="showDialog"
      :width="`${dialogWidth}px`"
      :cutline="dialogCutline"
      :append-to-body="true"
      :close-on-click-modal="false"
      :show-close="data.svgImgName?false:true"
      @close="handleClose"
    >
      <div :class="`align-center pt48 ${data.msg ? 'pb24' : 'pb48'} pl52 pr52`" v-if="dialogType === 'submit'">
        <div class="mb24" v-if="data.svgImgName">
          <img class="inline-block w88 h88" :src="pendingIcon" v-if="data.svgImgName==='tip'">
          <yxtf-svg v-else width="88px" height="88px" :icon-class="`icons/f_feedback-${data.svgImgName}`" />
        </div>
        <div class="c-cC26 fs24 fw500 hl32" v-if="data.title">{{data.title}}</div>
        <div class="c-cC75 fs14 mt12" v-if="data.info" v-html="data.info"></div>
        <div class="mt40">
          <yxt-button size='large' type="primary" @click.stop="cancelCb">{{ language().btn_view_my}}</yxt-button>
          <yxt-button v-if="data.rangeEnrollCount>0 &&  (data.allowEnrollCount>0 ||data.allowEnrollCount === -1 ) && data.svgImgName !=='warning'" class="ml16" size="large" @click.stop="continueCb">{{ language().txt_continue_signup }}</yxt-button>
          <yxt-button v-else class="ml16" size="large" @click.stop="okCb">{{ language().btn_view_details }}</yxt-button>
        </div>
        <pre class="bc-cCF5 pl16 pr16 pt16 pb16 rl4 rr4 rt4 rb4 align-left mt24" v-if="data.msg" v-html="data.msg"></pre>
      </div>
      <div class="pl24 pr24" v-else-if="dialogType === 'cancel'">
        <span class="fs14 c-cC8C" v-if="data.giveupTip">{{data.giveupTip}}</span>
        <yxtf-input class="mt16 mb14" :rows="4" v-model="data.reason" type="textarea" :placeholder="language().msg_text_reason" maxlength="200"></yxtf-input>
      </div>
      <div class="fixed top0 left0 right0 bottom0 bc-cCFF" v-else-if="dialogType === 'userSelector'">
        <user-selector :audit-status-list="auditStatus" :max="data.max" @close="cancelCb" @sure="okCb" @getData="getData"></user-selector>
      </div>
      <div v-else-if="dialogType === 'upload'">
        <div class="fs14 h24 c-cC8C mb16">{{language().msg_upload_info.replace('$types', data.attachTypeOptionList.map(_ => ({ 1: language().lbl_file, 2: language().lbl_picture, 3: language().lbl_video }[_])).join('、'))}}</div>
        <div class="wh120 center pointer" v-if="data.attachments.length < uploadConfig.max">
          <yxtbiz-upload
            class="wh120"
            icon-class="plus"
            :filters="data.filters"
            config-key="AttachConfigKey"
            app-code="kng"
            module-name="test_module"
            function-name="test_function"
            md5
            :before-upload="beforeUpload"
            :on-progress="onProgress"
            :on-uploaded="onUploaded"
            :on-error="onError"
            :drag="true"
          ></yxtbiz-upload>
        </div>
        <div class="c-cC75 fs14 mt16" v-if="data.attachments">
          <div v-for="(item, index) in data.attachments" :key="index" :class="`${index ? 'mt8' : ''} h40 lh40 bc-cCF5-hover rtl4 rtr4 rbl4 rbr4`">
            <yxtf-svg class="wh24 relative left-3 top4 ml8" :icon-class="`icons/${getIconName(item.fileClass)}`" />
            <span class="fs14 c-cC26 relative top6 h20 inline-block ellipsis w148-max">{{item.name && item.name.replace(/\.[^.]+$/, '')}}</span>
            <span class="fs14 c-cC8C relative top1">.{{item.name && item.name.split('.').pop()}}</span>
            <span class="fs14 c-cC8C ml8 relative top1">{{getSize(item.size)}}</span>
            <span class="x-close fs14 c-cC8C ml8 pull-right mr16 pointer" @click.stop="close(item.uuid)">
              <yxtf-svg class="relative top4" width="20px" height="20px" icon-class="delete-1" />
            </span>
            <span class="fs14 c-cC8C ml8 relative top2 mr18 pull-right wh159-40" v-show="!item.error && item.progress !== 100">
              <yxtf-progress class="relative top-3" :percentage="item.progress">
                <span slot='content' class="c-cC75">{{item.progress}}%</span>
              </yxtf-progress>
            </span>
            <span :class="`fs12 ml8 relative top1 pull-right mr12 w58 ${!item.error ? 'c-cC8C' : 'c-cCRed'}`">{{item.error ? language().lbl_upload_failed : (item.progress === 100 ? language().lbl_upload_success : language().lbl_uploading_now)}}</span>
          </div>
        </div>
      </div>
      <span slot="footer" v-if="dialogFooter">
        <yxtf-button @click="cancelCb">{{ language().btn_cancel }}</yxtf-button>
        <yxtf-button type="primary" @click="okCb(data)">{{ language().btn_determine }}</yxtf-button>
      </span>
    </yxtf-dialog>
  </div>
</template>

<script>
import { i18n } from 'yxt-biz-pc/packages/common-util/changeLangs';
import { SDK } from '@xxbiz/signup';
import userSelector from './components/userSelector.vue';
import center from './pages/center/index.vue';
import details from './pages/center/details.vue';
import order from './pages/center/order.vue';
import my from './pages/center/my.vue';
import info from './pages/manage/info.vue';
import config from './pages/config/index.vue';
import manage from './pages/manage/index.vue';
import detail from './pages/manage/detail.vue';
import list from './pages/manage/list.vue';
import icon from './img/icon.png';
// 报名组件
const language = () => {
  if (!window.i18n) window.i18n = i18n;
  return SDK.getLanguage('pc');
};
export default {
  name: 'YxtbizSignup',
  // 国际化
  provide: {
    language
  },
  components: {
    userSelector
  },
  data() {
    return {
      // 结果
      pendingIcon: icon,
      language,
      showDialog: false,
      data: {},
      dialogType: '',
      dialogClass: '',
      dialogPaddingSize: 'larger',
      dialogTitle: '',
      dialogWidth: 0,
      dialogFooter: false,
      dialogCenter: false,
      dialogCutline: false,
      cancelCb: () => {},
      okCb: () => {},
      continueCb: ()=>{},
      // SDK
      SDK,
      signupStatus: [],
      auditStatus: [],
      enrollType: [],
      // 组件
      components: {
        // 报名中心
        center,
        // 报名详情
        details,
        // 报名订单
        order,
        // 我的报名
        my,
        // 报名配置
        config,
        // 配置
        manage,
        // 名额详情
        detail,
        // 报名列表
        list,
        // 审核信息
        info
      }
    };
  },
  props: {
    // 组件模式，center：报名中心，config：报名配置，order: 报名订单，details: 报名详情，my: 我的报名
    mod: {
      type: String,
      default: ''
    },
    align: {
      type: String,
      default: ''
    },
    ...center.props,
    ...details.props,
    ...order.props,
    ...my.props,
    ...detail.props,
    ...manage.props,
    ...config.props,
    ...info.props
  },
  methods: {
    orderSubmit(callback) {
      if (this.mod === 'order') {
        this.$refs.refSignup.openSponsor(callback);
      }
    },

    // 打开
    handleOpen(option, data, cancelCb, okCb, continueCb) {
      this.showDialog = true;
      this.$set(this, 'data', data);
      this.dialogType = option.type;
      this.dialogTitle = option.title;
      this.dialogClass = option.class;
      this.dialogPaddingSize = option.paddingSize;
      this.dialogWidth = option.width;
      this.dialogCenter = option.center;
      this.dialogFooter = option.footer;
      this.dialogCutline = option.cutline;
      this.cancelCb = cancelCb;
      this.okCb = okCb;
      this.continueCb = continueCb;
    },
    // 关闭
    handleClose() {
      this.showDialog = false;
    },
    // 关闭
    handleClose2() {
      this.showDialog = false;
      if (this.dialogType === 'submit') {
        this.$emit('toDetails', this.data.id);
      }
    },
    // 获取大小
    getSize(size) {
      if (!size) {
        return '0 B';
      }
      if (size < 1024) {
        return size.toFixed() + ' B';
      }
      size = size / 1024;
      if (size < 1024) {
        return size.toFixed() + ' K';
      }
      size = size / 1024;
      if (size < 1024) {
        return size.toFixed() + ' M';
      }
      size = size / 1024;
      return size.toFixed() + ' G';
    },
    // 文件图标
    getIconName(fileClass) {
      if (
        ['word', 'excel', 'ppt', 'pdf', 'img', 'video', 'audio', 'zip'].includes(
          fileClass
        )
      ) {
        return `f_kng-${fileClass}`;
      }
      return 'f_kng-third';
    },
    // 上传前
    beforeUpload(file) {
      this.data.attachments.push({
        uuid: file.uuid,
        id: file.id || '',
        extension: file.extension,
        fileClass: file.fileClass,
        fileType: file.fileType,
        fullUrl: file.fullUrl || '',
        type: file.type,
        name: file.name,
        size: file.size,
        progress: 0
      });
    },
    // 上传中
    onProgress(file, progress) {
      const f = this.getFile(file.uuid);
      if (f) {
        f.progress = parseInt(progress.toFixed(2) * 100, 10);
      }
    },
    // 关闭文件
    close(uuid) {
      this.data.attachments = this.data.attachments.filter(_ => _.uuid !== uuid);
    },
    // 上传成功
    onUploaded(file) {
      for (let i = 0; i < this.data.attachments.length; i++) {
        if (this.data.attachments[i].uuid === file.uuid) {
          this.data.attachments[i].id = file.id;
          this.data.attachments[i].fullUrl = file.fullUrl;
          return;
        }
      }
    },
    // 错误
    onError(error) {
      if (error === 'oversize') {
        this.$message.error(this.$t('pc_biz_imgcropper_msg_oversize'/* 您选择的内容大小已超过允许的大小，请确认! */));
      } else if (error === 'forbidden') {
        this.$message.error(this.$t('pc_biz_imgcropper_msg_type'/* 您选择的内容格式不符合，请确认! */));
      }
    },
    // 异常提示
    fmessage(data, callback) {
      if (data && data.error) {
        this.$fmessage({ message: data.error.message, type: 'warning' });
      } else {
        if (callback) callback(data);
      }
    },
    // 找文件
    getFile(uuid) {
      for (const f of this.data.attachments) {
        if (f.uuid === uuid) {
          return f;
        }
      }
    },
    // 人员数据
    getData(...params) {
      this.data.getData(...params);
    },
    // 传值
    setParams(id, key, value) {
      if (sessionStorage.signup) {
        const data = JSON.parse(sessionStorage.signup);
        if (data[id]) {
          data[id][key] = value;
        } else {
          data[id] = {
            [key]: value
          };
        }
        sessionStorage.signup = JSON.stringify(data);
      } else {
        sessionStorage.signup = JSON.stringify({
          [id]: {
            [key]: value
          }
        });
      }
    },
    // 取值
    getParams(id, key) {
      if (sessionStorage.signup) {
        const data = JSON.parse(sessionStorage.signup);
        if (data[id] && data[id][key] !== undefined) {
          const value = data[id][key];
          // delete data[id][key];
          sessionStorage.signup = JSON.stringify(data);
          return value;
        }
      }
    },
    // 报名设置保存
    async saveSettings() {
      if (this.mod === 'config') {
        if (this.$refs.refSignup) {
          await this.$refs.refSignup.saveSettings();
        }
      } else {
        console.error('仅在配置中心使用');
      }
    },
    // 取消
    cancel() {
      if (this.mod === 'config') {
        if (this.$refs.refSignup) {
          this.$refs.refSignup.cancel();
        }
      } else {
        console.error('仅在配置中心使用');
      }
    }
  },
  computed: {
    // 审核状态对象
    auditStatusObj() {
      const obj = {};
      for (let i = 0; i < this.auditStatus.length; i++) {
        if (this.auditStatus[i].value !== undefined) {
          obj[this.auditStatus[i].value] = this.auditStatus[i];
        }
      }
      return obj;
    },
    // 报名状态对象
    signupStatusObj() {
      const obj = {};
      for (let i = 0; i < this.signupStatus.length; i++) {
        if (this.signupStatus[i].value !== undefined) {
          obj[this.signupStatus[i].value] = this.signupStatus[i];
        }
      }
      return obj;
    },
    // 报名方式
    enrollTypeObj() {
      const obj = {};
      for (let i = 0; i < this.enrollType.length; i++) {
        if (this.enrollType[i].value !== undefined) {
          obj[this.enrollType[i].value] = this.enrollType[i];
        }
      }
      return obj;
    }
  },
  created() {
    localStorage.setItem('signup_source', 501);
    // 配置
    if (!window.i18n) window.i18n = i18n;
    const { signupStatus, auditStatus, enrollType } = SDK.getCodes('pc');
    // 报名状态
    this.signupStatus = [...signupStatus];
    // 审核状态
    this.auditStatus = [...auditStatus];
    // 报名方式
    this.enrollType = [...enrollType];
  }
};
</script>
